import React, { useEffect, useMemo, useState } from 'react';
import './AdminVendors.css';
import { apiClient, endpoints } from '../../api';
import { getApiKey } from '../../utils/auth';

const AdminKYCReview = () => {
  // vendor-specific document state removed
  const [list, setList] = useState([]);
  const [total, setTotal] = useState(0);
  const [filters, setFilters] = useState({ vendor: '', document_type: '', status: '', expiry_from: '', expiry_to: '' });
  const [page, setPage] = useState(1);
  const [limit] = useState(20);
  // vendor-specific review state removed
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  // Vendor-specific state removed
  const [summary, setSummary] = useState(null);
  const [auditLoading, setAuditLoading] = useState(false);
  const [auditGlobal, setAuditGlobal] = useState([]);
  const [auditTotal, setAuditTotal] = useState(0);
  const [auditFilters, setAuditFilters] = useState({ vendor: '', action: '', admin: '' });
  const [auditPage, setAuditPage] = useState(1);
  // Vendor status update state removed
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalDoc, setModalDoc] = useState(null);
  const [expected, setExpected] = useState({ name: '', pan: '' });
  const [buttonLoading, setButtonLoading] = useState({});
  
  // Sorting & bulk selection state
  const [sortBy, setSortBy] = useState('uploaded_at');
  const [sortDir, setSortDir] = useState('desc');
  const [selectedRows, setSelectedRows] = useState(new Set());

  const adminHeaders = { 'x-admin-key': getApiKey() };

  // vendor-specific image display logic removed

  // loadVendors function removed

  // setVendorStatus function removed

  // loadDocs function removed (vendor-specific)

  const openPreviewModal = async (docId) => {
    try {
      // Find in current list instead of docs
      const doc = (list || []).find(d => String(d.id) === String(docId));
      setModalDoc(doc || null);
      setIsModalOpen(true);
    } catch (_) {
      setIsModalOpen(true);
    }
  };

  const closePreviewModal = () => {
    setIsModalOpen(false);
    setModalDoc(null);
  };

  const loadAll = async () => {
    try {
      setLoading(true);
      const params = { ...filters, page, limit };
      const { data } = await apiClient.get(endpoints.adminKycDocuments, { params, headers: adminHeaders });
      let items = data.items || [];
      // Client-side sorting (fallback if backend not providing order)
      items = [...items].sort((a, b) => {
        const dir = sortDir === 'asc' ? 1 : -1;
        const getVal = (row) => {
          if (sortBy === 'uploaded_at') return new Date(row.uploaded_at || 0).getTime();
          if (sortBy === 'expiry_date') return row.expiry_date ? new Date(row.expiry_date).getTime() : 0;
          if (sortBy === 'status') return String(row.doc_status || '');
          return new Date(row.uploaded_at || 0).getTime();
        };
        const va = getVal(a); const vb = getVal(b);
        if (va < vb) return -1 * dir;
        if (va > vb) return 1 * dir;
        return 0;
      });
      setList(items);
      setTotal(Number(data.total || 0));
      // Reset bulk selection on new data
      setSelectedRows(new Set());
    } catch (e) {
      setError('Failed to load KYC documents');
    } finally {
      setLoading(false);
    }
  };

  const loadSummary = async () => {
    try {
      const params = { vendor: filters.vendor, document_type: filters.document_type, status: filters.status, date_from: filters.submitted_from, date_to: filters.submitted_to };
      const { data } = await apiClient.get(endpoints.adminKycSummary, { params, headers: adminHeaders });
      setSummary(data);
    } catch (_) {}
  };

  // loadAudit function removed (vendor-specific)

  const loadAuditGlobal = async () => {
    try {
      setAuditLoading(true);
      const params = { ...auditFilters, page: auditPage, limit: 20 };
      const { data } = await apiClient.get(endpoints.adminKycAudit, { params, headers: adminHeaders });
      setAuditGlobal(data.items || []);
      setAuditTotal(Number(data.total || 0));
    } catch (e) {
      setError('Failed to load audit');
    } finally {
      setAuditLoading(false);
    }
  };

  // Helper function to show full OCR text in a modal
  const showFullTextModal = (fullText, title = 'Complete OCR Text', analysis = null) => {
    // Create modal overlay
    const modalOverlay = document.createElement('div');
    modalOverlay.className = 'kyc-ocr-modal-overlay';
    
    // Create modal content
    const modal = document.createElement('div');
    modal.className = 'kyc-ocr-modal';
    
    modal.innerHTML = `
      <div style="display: flex; align-items: center; justify-content: space-between; padding: 24px; border-bottom: 1px solid #e5e7eb; background: #f8fafc;">
        <div>
          <h3 style="font-size: 20px; font-weight: 600; color: #111827; margin: 0 0 4px 0;">📄 ${title}</h3>
          <div style="display: flex; align-items: center; gap: 12px;">
            <p style="font-size: 14px; color: #64748b; margin: 0;">${fullText.length} characters extracted from document</p>
            ${analysis ? `
              <span style="padding: 3px 8px; background: ${analysis.confidence === 'high' ? '#dcfce7' : analysis.confidence === 'medium' ? '#fef3c7' : '#fee2e2'}; color: ${analysis.confidence === 'high' ? '#166534' : analysis.confidence === 'medium' ? '#92400e' : '#991b1b'}; border-radius: 6px; font-size: 11px; font-weight: 600; text-transform: uppercase;">
                ${analysis.confidence} Quality (${analysis.readableRatio}% readable)
              </span>
            ` : ''}
          </div>
        </div>
        <button id="close-modal" style="width: 32px; height: 32px; border: none; background: #f3f4f6; border-radius: 8px; font-size: 18px; color: #64748b; cursor: pointer; display: flex; align-items: center; justify-content: center;">×</button>
      </div>
      <div style="flex: 1; overflow: hidden; display: flex; flex-direction: column;">
        ${analysis && analysis.readableWords.length > 0 ? `
          <div style="padding: 16px 24px; background: #f0fdf4; border-bottom: 1px solid #e5e7eb;">
            <div style="font-size: 12px; font-weight: 600; color: #166534; margin-bottom: 6px;">📝 Readable Words Detected:</div>
            <div style="font-size: 12px; color: #166534; line-height: 1.4;">
              ${analysis.readableWords.slice(0, 20).join(', ')}${analysis.readableWords.length > 20 ? ` ... and ${analysis.readableWords.length - 20} more` : ''}
            </div>
          </div>
        ` : ''}
        <div style="padding: 24px; flex: 1; overflow-y: auto;">
          <div class="kyc-ocr-text-display">
${fullText}
          </div>
        </div>
        <div style="padding: 20px; border-top: 1px solid #e5e7eb; background: #f8fafc; display: flex; gap: 12px; justify-content: flex-end; flex-wrap: wrap;">
          <button id="copy-full-text" style="padding: 10px 20px; background: #3b82f6; color: white; border: none; border-radius: 8px; font-size: 14px; cursor: pointer; font-weight: 500; display: flex; align-items: center; gap: 6px;">
            📋 Copy All Text
          </button>
          <button id="toggle-highlight" style="padding: 10px 20px; background: #f59e0b; color: white; border: none; border-radius: 8px; font-size: 14px; cursor: pointer; font-weight: 500; display: flex; align-items: center; gap: 6px;">
            🎨 Highlight Important
          </button>
          <button id="select-all-text" style="padding: 10px 20px; background: #6b7280; color: white; border: none; border-radius: 8px; font-size: 14px; cursor: pointer; font-weight: 500; display: flex; align-items: center; gap: 6px;">
            🔍 Select All
          </button>
        </div>
      </div>
    `;
    
    modalOverlay.appendChild(modal);
    document.body.appendChild(modalOverlay);
    
    // Add event listeners
    const closeModal = () => {
      if (document.body.contains(modalOverlay)) {
        document.body.removeChild(modalOverlay);
      }
    };
    
    modal.querySelector('#close-modal').onclick = closeModal;
    modalOverlay.onclick = (e) => {
      if (e.target === modalOverlay) closeModal();
    };
    
    // Copy functionality
    modal.querySelector('#copy-full-text').onclick = async () => {
      try {
        await navigator.clipboard.writeText(fullText);
        const button = modal.querySelector('#copy-full-text');
        button.innerHTML = '✓ Copied!';
        button.style.background = '#10b981';
        setTimeout(() => {
          button.innerHTML = '📋 Copy All Text';
          button.style.background = '#3b82f6';
        }, 2000);
      } catch (err) {
        console.error('Failed to copy text:', err);
      }
    };
    
    // Highlight toggle functionality
    let isHighlighted = false;
    modal.querySelector('#toggle-highlight').onclick = () => {
      const textDiv = modal.querySelector('.kyc-ocr-text-display');
      const button = modal.querySelector('#toggle-highlight');
      
      if (!isHighlighted) {
        textDiv.innerHTML = highlightImportantText(fullText);
        button.innerHTML = '📝 Show Plain Text';
        button.style.background = '#10b981';
        isHighlighted = true;
      } else {
        textDiv.textContent = fullText;
        button.innerHTML = '🎨 Highlight Important';
        button.style.background = '#f59e0b';
        isHighlighted = false;
      }
    };
    
    // Select all functionality
    modal.querySelector('#select-all-text').onclick = () => {
      const textDiv = modal.querySelector('.kyc-ocr-text-display');
      if (textDiv) {
        const range = document.createRange();
        range.selectNodeContents(textDiv);
        const selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
      }
    };
    
    // Close on Escape key
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        closeModal();
        document.removeEventListener('keydown', handleEscape);
      }
    };
    document.addEventListener('keydown', handleEscape);
  };

  // Helper function to highlight important patterns in OCR text
  const highlightImportantText = (text) => {
    if (!text) return text;
    
    let highlightedText = text;
    
    // Highlight PAN numbers
    highlightedText = highlightedText.replace(
      /([A-Z]{5}[0-9]{4}[A-Z])/g, 
      '<span style="background: #fef3c7; color: #92400e; padding: 2px 4px; border-radius: 3px; font-weight: 600;">$1</span>'
    );
    
    // Highlight FSSAI numbers
    highlightedText = highlightedText.replace(
      /([0-9]{14})/g,
      '<span style="background: #dcfce7; color: #166534; padding: 2px 4px; border-radius: 3px; font-weight: 600;">$1</span>'
    );
    
    // Highlight Aadhaar numbers
    highlightedText = highlightedText.replace(
      /([0-9]{4}\s?[0-9]{4}\s?[0-9]{4})/g,
      '<span style="background: #fce7f3; color: #be185d; padding: 2px 4px; border-radius: 3px; font-weight: 600;">$1</span>'
    );
    
    return highlightedText;
  };

  // Helper function to clean and format OCR text for better readability
  const formatOCRText = (rawText) => {
    if (!rawText) return '';
    
    return rawText
      // Remove excessive whitespace but preserve line breaks
      .replace(/[ \t]+/g, ' ')
      // Clean up multiple line breaks
      .replace(/\n\s*\n\s*\n/g, '\n\n')
      // Remove leading/trailing whitespace from each line
      .split('\n')
      .map(line => line.trim())
      .join('\n')
      // Final trim
      .trim();
  };

  // Helper function to clean garbled OCR text and make it more readable
  const cleanGarbledText = (text) => {
    if (!text) return '';
    
    // Advanced cleaning for heavily garbled OCR text
    let cleaned = text
      // Remove excessive special character clusters (common OCR errors)
      .replace(/[^\w\s\n.,;:!?()-]{3,}/g, ' ')
      // Clean up symbol clusters that are likely OCR errors
      .replace(/[&£$%@#*+=\[\]{}|\\<>~`^_-]{2,}/g, ' ')
      // Remove isolated special characters surrounded by spaces
      .replace(/\s+[&£$%@#*+=\[\]{}|\\<>~`^_-]+\s+/g, ' ')
      // Clean up excessive punctuation
      .replace(/[.,;:!?]{2,}/g, '.')
      // Remove excessive underscores and dashes
      .replace(/[_-]{3,}/g, ' ')
      // Clean up number-symbol combinations that look like OCR errors
      .replace(/\d+[&£$%@#*+=\[\]{}|\\<>~`^_-]+/g, ' ')
      // Remove symbol-letter combinations that are likely errors
      .replace(/[&£$%@#*+=\[\]{}|\\<>~`^_-]+[a-zA-Z]/g, ' ')
      // Clean up excessive dots
      .replace(/\.{3,}/g, '...')
      // Remove single characters surrounded by symbols (likely OCR errors)
      .replace(/[^\w\s][a-zA-Z][^\w\s]/g, ' ')
      // Clean up excessive spaces
      .replace(/\s{2,}/g, ' ')
      // Clean up line breaks
      .replace(/\n\s*\n\s*\n/g, '\n\n')
      // Remove lines that are mostly symbols (likely OCR garbage)
      .split('\n')
      .filter(line => {
        const symbolCount = (line.match(/[^\w\s]/g) || []).length;
        const totalLength = line.length;
        return totalLength === 0 || (symbolCount / Math.max(totalLength, 1)) < 0.7;
      })
      .join('\n')
      .trim();
    
    return cleaned;
  };

  // Helper function to extract readable words from garbled text
  const extractReadableContent = (text) => {
    if (!text) return { cleanText: '', readableWords: [], confidence: 'low' };
    
    // Extract words that look like real text (2+ characters, mostly letters)
    const words = text.split(/\s+/);
    const readableWords = words.filter(word => {
      // Remove punctuation for analysis
      const cleanWord = word.replace(/[^\w]/g, '');
      // Accept words that are 2+ characters and at least 60% letters
      if (cleanWord.length < 2) return false;
      const letterCount = (cleanWord.match(/[a-zA-Z]/g) || []).length;
      const letterRatio = letterCount / cleanWord.length;
      return letterRatio >= 0.6;
    });
    
    // Calculate confidence based on readable content ratio
    const totalWords = words.filter(w => w.trim().length > 0).length;
    const readableRatio = readableWords.length / Math.max(totalWords, 1);
    
    let confidence = 'low';
    if (readableRatio > 0.6) confidence = 'high';
    else if (readableRatio > 0.3) confidence = 'medium';
    
    const cleanText = cleanGarbledText(text);
    
    return {
      cleanText,
      readableWords,
      confidence,
      readableRatio: Math.round(readableRatio * 100)
    };
  };

  // Helper function to extract any meaningful patterns from heavily garbled text
  const extractMeaningfulPatterns = (text) => {
    if (!text) return [];
    
    const patterns = [];
    
    // Try to find number sequences that might be document numbers
    const numberSequences = text.match(/\d{4,}/g);
    if (numberSequences) {
      numberSequences.forEach(seq => {
        if (seq.length >= 10 && seq.length <= 16) {
          patterns.push({ type: 'Possible Document Number', value: seq });
        }
      });
    }
    
    // Try to find letter sequences that might be names or words
    const letterSequences = text.match(/[A-Za-z]{3,}/g);
    if (letterSequences) {
      const uniqueSequences = [...new Set(letterSequences)]
        .filter(seq => seq.length >= 4)
        .slice(0, 5); // Limit to 5 most likely candidates
      
      uniqueSequences.forEach(seq => {
        patterns.push({ type: 'Possible Text', value: seq });
      });
    }
    
    // Try to find mixed alphanumeric sequences (PAN and similar patterns)
    const mixedSequences = text.match(/[A-Z]{2,}[0-9]{4,}[A-Z]?/g);
    if (mixedSequences) {
      mixedSequences.forEach(seq => {
        if (seq.length >= 6) {
          patterns.push({ type: 'Possible ID Pattern', value: seq });
        }
      });
    }
    
    return patterns;
  };
  const extractSuggestions = (text) => {
    const suggestions = [];
    const upperText = text.toUpperCase();
    
    // PAN pattern: 5 letters + 4 digits + 1 letter
    const panMatch = text.match(/[A-Z]{5}[0-9]{4}[A-Z]/g);
    if (panMatch) {
      suggestions.push({ type: 'PAN', value: panMatch[0] });
    }
    
    // FSSAI pattern: 14 digits
    const fssaiMatch = text.match(/[0-9]{14}/g);
    if (fssaiMatch) {
      suggestions.push({ type: 'FSSAI', value: fssaiMatch[0] });
    }
    
    // Aadhaar pattern: 12 digits (often with spaces)
    const aadhaarMatch = text.match(/[0-9]{4}\s?[0-9]{4}\s?[0-9]{4}/g);
    if (aadhaarMatch) {
      suggestions.push({ type: 'Aadhaar', value: aadhaarMatch[0].replace(/\s/g, '') });
    }
    
    // Try to find names (words that are likely names - capitalized words)
    const nameMatches = text.match(/[A-Z][a-z]+(?:\s+[A-Z][a-z]+)*/g);
    if (nameMatches) {
      // Filter out common non-name words and take the longest match
      const filteredNames = nameMatches.filter(name => 
        !['GOVERNMENT', 'INDIA', 'PERMANENT', 'ACCOUNT', 'NUMBER', 'INCOME', 'TAX', 'DEPARTMENT'].includes(name.toUpperCase()) &&
        name.length > 3
      );
      if (filteredNames.length > 0) {
        const longestName = filteredNames.reduce((a, b) => a.length > b.length ? a : b);
        suggestions.push({ type: 'Name', value: longestName });
      }
    }
    
    return suggestions;
  };

  const runOCR = async (docId) => {
    try {
      // Show loading state
      setButtonLoading(prev => ({ ...prev, [`ocr-${docId}`]: true }));
      
      const loadingToast = document.createElement('div');
      loadingToast.innerHTML = `
        <div style="display: flex; align-items: center; gap: 8px;">
          <div style="width: 16px; height: 16px; border: 2px solid #3b82f6; border-top: 2px solid transparent; border-radius: 50%; animation: spin 1s linear infinite;"></div>
          OCR processing... This may take a few seconds.
        </div>
      `;
      loadingToast.style.cssText = 'position: fixed; top: 20px; right: 20px; background: #fff; padding: 16px 20px; border: 2px solid #3b82f6; border-radius: 12px; z-index: 10000; box-shadow: 0 4px 12px rgba(0,0,0,0.15); font-size: 14px; color: #1f2937;';
      
      // Add spin animation
      const style = document.createElement('style');
      style.textContent = '@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }';
      document.head.appendChild(style);
      document.body.appendChild(loadingToast);

      const response = await apiClient.post(endpoints.adminDocOCR(docId), {}, { headers: adminHeaders });
      
      // Remove loading toast
      document.body.removeChild(loadingToast);
      document.head.removeChild(style);
      
      if (response.data?.text) {
        // Clean and format the extracted text for better display
        const rawText = response.data.text || '';
        const extractedText = formatOCRText(rawText);
        const analysis = extractReadableContent(extractedText);
        
        // Check if text is heavily garbled (very low confidence)
        const isHeavilyGarbled = analysis.confidence === 'low' && analysis.readableRatio < 20;
        
        const preview = analysis.cleanText.substring(0, 500);
        const hasMore = analysis.cleanText.length > 500;
        
        // Try to extract common patterns (PAN, name, etc.)
        const suggestions = extractSuggestions(extractedText);
        
        // For heavily garbled text, also try to extract any meaningful patterns
        const meaningfulPatterns = isHeavilyGarbled ? extractMeaningfulPatterns(rawText) : [];
        
        // Show success with extracted text preview
        const successToast = document.createElement('div');
        successToast.innerHTML = `
          <div style="margin-bottom: 12px; font-weight: 600; color: #059669; display: flex; align-items: center; gap: 8px;">
            <span style="font-size: 16px;">✓</span> OCR Completed Successfully!
          </div>
          <div style="margin-bottom: 8px; font-size: 12px; color: #6b7280; font-weight: 500; display: flex; align-items: center; gap: 8px;">
            <span>Extracted ${extractedText.length} characters from document</span>
            <span style="padding: 2px 6px; background: ${analysis.confidence === 'high' ? '#dcfce7' : analysis.confidence === 'medium' ? '#fef3c7' : '#fee2e2'}; color: ${analysis.confidence === 'high' ? '#166534' : analysis.confidence === 'medium' ? '#92400e' : '#991b1b'}; border-radius: 4px; font-size: 10px; font-weight: 600; text-transform: uppercase;">
              ${analysis.confidence} Quality (${analysis.readableRatio}% readable)
            </span>
          </div>
          ${analysis.confidence === 'low' ? `
            <div style="margin-bottom: 12px; padding: 10px; background: #fef3c7; border: 1px solid #f59e0b; border-radius: 8px;">
              <div style="font-size: 12px; font-weight: 600; color: #92400e; margin-bottom: 4px;">⚠️ Low Quality OCR Result</div>
              <div style="font-size: 11px; color: #92400e;">
                The extracted text contains many unreadable characters. This might be due to:
                <br/>• Poor image quality or resolution
                <br/>• Handwritten text or complex fonts
                <br/>• Skewed or rotated document
                <br/>• Low contrast or blurry image
                ${isHeavilyGarbled ? '<br/>• Document may need manual review or re-scanning' : ''}
              </div>
            </div>
          ` : ''}
          ${suggestions.length > 0 ? `
            <div style="margin-bottom: 12px; padding: 10px; background: #eff6ff; border: 1px solid #bfdbfe; border-radius: 8px;">
              <div style="font-size: 12px; font-weight: 600; color: #1d4ed8; margin-bottom: 6px;">🔍 Auto-detected Information:</div>
              ${suggestions.map(s => `<div style="font-size: 12px; color: #1e40af; margin-bottom: 2px;"><strong>${s.type}:</strong> <span style="font-family: 'Courier New', monospace; background: #f0f9ff; padding: 2px 4px; border-radius: 3px;">${s.value}</span></div>`).join('')}
            </div>
          ` : ''}
          ${meaningfulPatterns.length > 0 ? `
            <div style="margin-bottom: 12px; padding: 10px; background: #fef3c7; border: 1px solid #f59e0b; border-radius: 8px;">
              <div style="font-size: 12px; font-weight: 600; color: #92400e; margin-bottom: 6px;">🔍 Possible Patterns Found in Garbled Text:</div>
              ${meaningfulPatterns.map(p => `<div style="font-size: 12px; color: #92400e; margin-bottom: 2px;"><strong>${p.type}:</strong> <span style="font-family: 'Courier New', monospace; background: #fef3c7; padding: 2px 4px; border-radius: 3px;">${p.value}</span></div>`).join('')}
              <div style="font-size: 11px; color: #92400e; margin-top: 6px; font-style: italic;">⚠️ These patterns were extracted from garbled text and may not be accurate</div>
            </div>
          ` : ''}
          ${analysis.readableWords.length > 0 ? `
            <div style="margin-bottom: 12px; padding: 10px; background: #f0fdf4; border: 1px solid #22c55e; border-radius: 8px;">
              <div style="font-size: 12px; font-weight: 600; color: #166534; margin-bottom: 6px;">📝 Readable Words Found:</div>
              <div style="font-size: 11px; color: #166534; line-height: 1.4;">
                ${analysis.readableWords.slice(0, 10).join(', ')}${analysis.readableWords.length > 10 ? ` ... and ${analysis.readableWords.length - 10} more` : ''}
              </div>
            </div>
          ` : ''}
          <div style="margin-bottom: 12px;">
            <div style="font-size: 12px; font-weight: 600; color: #374151; margin-bottom: 6px;">📄 Extracted Text Preview:</div>
            <div class="kyc-ocr-preview" style="font-family: 'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, sans-serif; font-size: 14px; line-height: 1.8; letter-spacing: 0.8px; word-spacing: 2px;">
${preview}${hasMore ? '\n\n... (showing first 500 characters)' : ''}
            </div>
          </div>
          <div style="margin-top: 12px; display: flex; gap: 8px; align-items: center; flex-wrap: wrap;">
            <button id="copy-ocr-text" style="padding: 8px 16px; background: #3b82f6; color: white; border: none; border-radius: 8px; font-size: 12px; cursor: pointer; font-weight: 500; display: flex; align-items: center; gap: 4px;">
              📋 Copy Full Text
            </button>
            <button id="view-full-text" style="padding: 8px 16px; background: #6b7280; color: white; border: none; border-radius: 8px; font-size: 12px; cursor: pointer; font-weight: 500; display: flex; align-items: center; gap: 4px;">
              👁️ View Full Text
            </button>
            <button id="view-cleaned-text" style="padding: 8px 16px; background: #10b981; color: white; border: none; border-radius: 8px; font-size: 12px; cursor: pointer; font-weight: 500; display: flex; align-items: center; gap: 4px;">
              🧹 View Cleaned
            </button>
            ${suggestions.length > 0 || meaningfulPatterns.length > 0 ? `
              <button id="apply-suggestions" style="padding: 8px 16px; background: #f59e0b; color: white; border: none; border-radius: 8px; font-size: 12px; cursor: pointer; font-weight: 500; display: flex; align-items: center; gap: 4px;">
                ✨ Apply Suggestions
              </button>
            ` : ''}
          </div>
        `;
        successToast.style.cssText = 'position: fixed; top: 20px; right: 20px; background: #fff; padding: 24px; border: 2px solid #10b981; border-radius: 16px; z-index: 10000; box-shadow: 0 12px 32px rgba(0,0,0,0.15); font-size: 14px; max-width: 550px; min-width: 450px;';
        document.body.appendChild(successToast);
        
        // Add view full text functionality
        const viewFullButton = successToast.querySelector('#view-full-text');
        viewFullButton.onclick = (e) => {
          e.stopPropagation();
          showFullTextModal(extractedText, 'Original OCR Text');
        };
        
        // Add view cleaned text functionality
        const viewCleanedButton = successToast.querySelector('#view-cleaned-text');
        viewCleanedButton.onclick = (e) => {
          e.stopPropagation();
          showFullTextModal(analysis.cleanText, 'Cleaned OCR Text', analysis);
        };
        
        // Add apply suggestions functionality
        if (suggestions.length > 0 || meaningfulPatterns.length > 0) {
          const applyButton = successToast.querySelector('#apply-suggestions');
          applyButton.onclick = (e) => {
            e.stopPropagation();
            
            // Apply regular suggestions first
            suggestions.forEach(suggestion => {
              if (suggestion.type === 'PAN' || suggestion.type === 'FSSAI' || suggestion.type === 'Aadhaar') {
                setExpected(prev => ({ ...prev, pan: suggestion.value }));
              } else if (suggestion.type === 'Name') {
                setExpected(prev => ({ ...prev, name: suggestion.value }));
              }
            });
            
            // Apply meaningful patterns from garbled text
            meaningfulPatterns.forEach(pattern => {
              if (pattern.type === 'Possible Document Number' || pattern.type === 'Possible ID Pattern') {
                setExpected(prev => ({ ...prev, pan: pattern.value }));
              } else if (pattern.type === 'Possible Text') {
                setExpected(prev => ({ ...prev, name: pattern.value }));
              }
            });
            
            applyButton.innerHTML = '✓ Applied!';
            applyButton.style.background = '#059669';
            setTimeout(() => {
              applyButton.innerHTML = '✨ Apply Suggestions';
              applyButton.style.background = '#f59e0b';
            }, 2000);
          };
        }
        const copyButton = successToast.querySelector('#copy-ocr-text');
        copyButton.onclick = async (e) => {
          e.stopPropagation();
          try {
            await navigator.clipboard.writeText(extractedText);
            copyButton.innerHTML = '✓ Copied!';
            copyButton.style.background = '#10b981';
            setTimeout(() => {
              copyButton.innerHTML = '📋 Copy Full Text';
              copyButton.style.background = '#3b82f6';
            }, 2000);
          } catch (err) {
            console.error('Failed to copy text:', err);
            copyButton.innerHTML = '❌ Copy Failed';
            copyButton.style.background = '#ef4444';
            setTimeout(() => {
              copyButton.innerHTML = '📋 Copy Full Text';
              copyButton.style.background = '#3b82f6';
            }, 2000);
          }
        };
        
        // Add click to dismiss (but not on copy button)
        successToast.style.cursor = 'pointer';
        successToast.title = 'Click to dismiss';
        successToast.onclick = (e) => {
          if (e.target.id !== 'copy-ocr-text' && document.body.contains(successToast)) {
            document.body.removeChild(successToast);
          }
        };
        
        // Auto remove after 8 seconds (longer for OCR results)
        setTimeout(() => {
          if (document.body.contains(successToast)) {
            document.body.removeChild(successToast);
          }
        }, 8000);
      } else {
        // Show success but no text extracted
        const successToast = document.createElement('div');
        successToast.innerHTML = `
          <div style="margin-bottom: 8px; font-weight: 600; color: #f59e0b;">⚠️ OCR Completed</div>
          <div style="font-size: 12px; color: #6b7280;">OCR processing finished, but no text was extracted from this document. This might be due to:</div>
          <ul style="font-size: 12px; color: #6b7280; margin: 8px 0; padding-left: 16px;">
            <li>Image quality is too low</li>
            <li>Document contains only images/graphics</li>
            <li>Text is handwritten or in unsupported format</li>
          </ul>
        `;
        successToast.style.cssText = 'position: fixed; top: 20px; right: 20px; background: #fff; padding: 16px 20px; border: 2px solid #f59e0b; border-radius: 12px; z-index: 10000; box-shadow: 0 4px 12px rgba(0,0,0,0.15); font-size: 14px; max-width: 400px;';
        document.body.appendChild(successToast);
        
        setTimeout(() => {
          if (document.body.contains(successToast)) {
            document.body.removeChild(successToast);
          }
        }, 6000);
      }
      
      await loadAll();
    } catch (e) {
      // Remove loading message if it exists
      const loadingToast = document.querySelector('div[style*="OCR processing"]');
      if (loadingToast && document.body.contains(loadingToast)) {
        document.body.removeChild(loadingToast);
      }
      
      console.error('OCR Error:', e);
      const errorMsg = e.response?.data?.error || 'OCR processing failed. Please try again.';
      
      // Show error toast
      const errorToast = document.createElement('div');
      errorToast.innerHTML = `
        <div style="margin-bottom: 8px; font-weight: 600; color: #dc2626;">✗ OCR Failed</div>
        <div style="font-size: 12px; color: #6b7280;">${errorMsg}</div>
      `;
      errorToast.style.cssText = 'position: fixed; top: 20px; right: 20px; background: #fff; padding: 16px 20px; border: 2px solid #ef4444; border-radius: 12px; z-index: 10000; box-shadow: 0 4px 12px rgba(0,0,0,0.15); font-size: 14px; max-width: 400px;';
      document.body.appendChild(errorToast);
      
      // Auto remove after 4 seconds
      setTimeout(() => {
        if (document.body.contains(errorToast)) {
          document.body.removeChild(errorToast);
        }
      }, 4000);
    } finally {
      setButtonLoading(prev => ({ ...prev, [`ocr-${docId}`]: false }));
    }
  };

  const verifyDoc = async (docId) => {
    try {
      // Ensure expected fields are properly formatted
      const payload = { 
        expected: {
          name: expected.name || '',
          pan: expected.pan || ''
        }
      };
      console.log('Verifying document with payload:', payload);
      
      await apiClient.post(endpoints.adminDocVerify(docId), payload, { headers: adminHeaders });
      alert('Document verification completed successfully!');
      await loadAll();
    } catch (e) {
      console.error('Verification error:', e);
      const errorMsg = e.response?.data?.error || 'Verification failed';
      alert('Verification failed: ' + errorMsg);
    }
  };

  const deleteDoc = async (docId) => {
    try {
      const ok = window.confirm('Are you sure you want to delete this document? This action cannot be undone.');
      if (!ok) return;
      
      await apiClient.delete(endpoints.adminDocDelete(docId), { headers: adminHeaders });
      alert('Document deleted successfully!');
      await loadAll();
    } catch (e) {
      console.error('Delete error:', e);
      const errorMsg = e.response?.data?.error || 'Failed to delete document';
      alert('Delete failed: ' + errorMsg);
    }
  };

  // submitReview function removed (vendor-specific)

  const toggleRowSelected = (id) => {
    setSelectedRows(prev => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id); else next.add(id);
      return next;
    });
  };

  const toggleAllSelected = () => {
    setSelectedRows(prev => {
      if (prev.size === list.length) return new Set();
      return new Set(list.map(r => r.id));
    });
  };

  const bulkApprove = async () => {
    if (selectedRows.size === 0) return;
    const ok = window.confirm(`Approve ${selectedRows.size} document(s)?`);
    if (!ok) return;
    try {
      for (const id of selectedRows) {
        // Use the direct approve endpoint to bypass status transitions
        await apiClient.post(endpoints.adminDocApprove(id), { notes: 'Bulk approved by admin' }, { headers: adminHeaders });
      }
      await loadAll();
      alert('Bulk approve completed');
    } catch (e) {
      console.error('Bulk approve error:', e);
      alert('Bulk approve failed (some items may be processed)');
    }
  };

  const bulkReject = async () => {
    if (selectedRows.size === 0) return;
    const reason = window.prompt(`Enter rejection reason for ${selectedRows.size} document(s):`, '');
    if (reason === null) return;
    try {
      for (const id of selectedRows) {
        await apiClient.post(endpoints.adminDocReject(id), { reason: reason || '' }, { headers: adminHeaders });
      }
      await loadAll();
      alert('Bulk reject completed');
    } catch (_) {
      alert('Bulk reject failed (some items may be processed)');
    }
  };

  useEffect(() => { loadAuditGlobal(); }, [auditFilters.vendor, auditFilters.action, auditFilters.admin, auditPage]);
  useEffect(() => { loadAll(); loadSummary(); }, [filters.vendor, filters.document_type, filters.status, filters.expiry_from, filters.expiry_to, page]);

  return (
    <div className="admin-vendors">
      <div className="admin-vendors-header">
        <div className="admin-vendors-header-content">
          <h1>KYC Review</h1>
          <p>Review vendor documents with OCR highlights</p>
        </div>
      </div>

      {error && <div style={{ color: '#b91c1c', marginBottom: 12 }}>{error}</div>}

      <div className="admin-vendors-filters" style={{ alignItems: 'center' }}>
        <div className="admin-filters-left">
          {/* Vendor selection removed */}
        </div>
        <div className="admin-filters-right" style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          {/* Vendor status controls removed */}
        </div>
      </div>

          {summary && (
            <>
            <div className="admin-vendors-header" style={{ marginTop: 8 }}>
              <div className="admin-vendors-header-content">
                <h2 style={{ margin: 0 }}>KYC Dashboard Overview</h2>
                <p style={{ margin: 0 }}>Snapshot of KYC progress across vendors</p>
              </div>
            </div>
            <div className="kyc-dashboard-grid">
              <div className="kyc-dashboard-card">
                <div className="kyc-card-icon"></div>
                <div className="kyc-card-content">
                  <div className="kyc-card-title">Total Vendors</div>
                  <div className="kyc-card-value">{summary.totalVendors}</div>
                </div>
              </div>
              <div className="kyc-dashboard-card">
                <div className="kyc-card-icon"></div>
                <div className="kyc-card-content">
                  <div className="kyc-card-title">Documents Submitted</div>
                  <div className="kyc-card-value">{summary.totalDocuments}</div>
                </div>
              </div>
              <div className="kyc-dashboard-card kyc-card-success">
                <div className="kyc-card-icon"></div>
                <div className="kyc-card-content">
                  <div className="kyc-card-title">Verified Documents</div>
                  <div className="kyc-card-value">{summary.verifiedDocuments}</div>
                </div>
              </div>
              <div className="kyc-dashboard-card kyc-card-warning">
                <div className="kyc-card-icon"></div>
                <div className="kyc-card-content">
                  <div className="kyc-card-title">Pending Verification</div>
                  <div className="kyc-card-value">{summary.pendingVerification}</div>
                </div>
              </div>
              <div className="kyc-dashboard-card kyc-card-error">
                <div className="kyc-card-icon"></div>
                <div className="kyc-card-content">
                  <div className="kyc-card-title">Rejected Documents</div>
                  <div className="kyc-card-value">{summary.rejectedDocuments}</div>
                </div>
              </div>
            </div>
            </>
          )}
          {summary && (
            <div className="kyc-expiring-alerts">
              <div className="kyc-alerts-header">
                <div className="kyc-alerts-icon"></div>
                <div className="kyc-alerts-title">Expiring Alerts (by retention)</div>
              </div>
              <div className="kyc-alerts-content">
                <div className="kyc-alert-item">
                  <span className="kyc-alert-period">30 days</span>
                  <span className="kyc-alert-count">{summary.expiring?.days30 || 0}</span>
                </div>
                <div className="kyc-alert-item">
                  <span className="kyc-alert-period">60 days</span>
                  <span className="kyc-alert-count">{summary.expiring?.days60 || 0}</span>
                </div>
                <div className="kyc-alert-item">
                  <span className="kyc-alert-period">90 days</span>
                  <span className="kyc-alert-count">{summary.expiring?.days90 || 0}</span>
                </div>
              </div>
            </div>
          )}
          <div className="admin-vendors-table-container">
          <div style={{ marginTop: 16 }}>
            <h3>All KYC Documents</h3>
          <div className="kyc-filters-section">
            <div className="kyc-filters-header">
              <h3>Filter & Search Documents</h3>
              <p>Use filters to find specific documents quickly</p>
            </div>
            
            <div className="kyc-filters-grid">
              <div className="kyc-filter-group">
                <label className="kyc-filter-label">Vendor Search</label>
                <input 
                  className="kyc-filter-input" 
                  placeholder="Search by vendor name or ID" 
                  value={filters.vendor} 
                  onChange={(e) => { setPage(1); setFilters({ ...filters, vendor: e.target.value }); }} 
                />
              </div>
              
              <div className="kyc-filter-group">
                <label className="kyc-filter-label">Document Type</label>
                <select 
                  className="kyc-filter-select" 
                  value={filters.document_type} 
                  onChange={(e) => { setPage(1); setFilters({ ...filters, document_type: e.target.value }); }}
                >
                  <option value="">All Document Types</option>
                  <option value="pan">PAN Card</option>
                  <option value="fssai">FSSAI License</option>
                  <option value="shopLicense">Shop License</option>
                  <option value="aadhaar">Aadhaar Card</option>
                  <option value="bankProof">Bank Proof</option>
                </select>
              </div>
              
              <div className="kyc-filter-group">
                <label className="kyc-filter-label">Status</label>
                <select 
                  className="kyc-filter-select" 
                  value={filters.status} 
                  onChange={(e) => { setPage(1); setFilters({ ...filters, status: e.target.value }); }}
                >
                  <option value="">All Statuses</option>
                  <option value="UPLOADED">Uploaded</option>
                  <option value="OCR_CHECK">OCR Check</option>
                  <option value="FLAGGED">Flagged</option>
                  <option value="MANUAL_REVIEW">Manual Review</option>
                  <option value="APPROVED">Approved</option>
                  <option value="REJECTED">Rejected</option>
                </select>
              </div>
              
              <div className="kyc-filter-group">
                <label className="kyc-filter-label">Verification Status</label>
                <select 
                  className="kyc-filter-select" 
                  value={filters.verification_status || ''} 
                  onChange={(e) => { setPage(1); setFilters({ ...filters, verification_status: e.target.value }); }}
                >
                  <option value="">All Verification Status</option>
                  <option value="PENDING">Pending</option>
                  <option value="VERIFIED">Verified</option>
                  <option value="REJECTED">Rejected</option>
                </select>
              </div>
              
              <div className="kyc-filter-group">
                <label className="kyc-filter-label">Sort By</label>
                <select 
                  className="kyc-filter-select" 
                  value={sortBy} 
                  onChange={(e) => { setSortBy(e.target.value); }}
                >
                  <option value="uploaded_at">Submitted Date</option>
                  <option value="expiry_date">Expiry Date</option>
                  <option value="status">Status</option>
                </select>
              </div>
              
              <div className="kyc-filter-group">
                <label className="kyc-filter-label">Sort Order</label>
                <select 
                  className="kyc-filter-select" 
                  value={sortDir} 
                  onChange={(e) => { setSortDir(e.target.value); }}
                >
                  <option value="desc">Newest First</option>
                  <option value="asc">Oldest First</option>
                </select>
              </div>
              
              <div className="kyc-filter-group">
                <label className="kyc-filter-label">From Date</label>
                <input 
                  type="date" 
                  className="kyc-filter-input" 
                  value={filters.submitted_from || ''} 
                  onChange={(e) => { setPage(1); setFilters({ ...filters, submitted_from: e.target.value }); }} 
                />
              </div>
              
              <div className="kyc-filter-group">
                <label className="kyc-filter-label">To Date</label>
                <input 
                  type="date" 
                  className="kyc-filter-input" 
                  value={filters.submitted_to || ''} 
                  onChange={(e) => { setPage(1); setFilters({ ...filters, submitted_to: e.target.value }); }} 
                />
              </div>
            </div>
          </div>
            <div className="kyc-bulk-actions">
              <div className="kyc-bulk-header">
                <h4>Bulk Actions</h4>
                <span className="kyc-selected-count">{selectedRows.size} document(s) selected</span>
              </div>
              <div className="kyc-bulk-buttons">
                <button className="kyc-bulk-btn kyc-bulk-select" onClick={toggleAllSelected}>
                  {selectedRows.size === list.length && list.length > 0 ? 'Unselect All' : 'Select All'}
                </button>
                <button className="kyc-bulk-btn kyc-bulk-approve" onClick={bulkApprove} disabled={selectedRows.size === 0}>
                  Bulk Approve
                </button>
                <button className="kyc-bulk-btn kyc-bulk-reject" onClick={bulkReject} disabled={selectedRows.size === 0}>
                  Bulk Reject
                </button>
              </div>
            </div>
            <div className="kyc-table-container">
              <table className="kyc-documents-table">
                <thead>
                  <tr>
                    <th className="kyc-col-checkbox"></th>
                    <th className="kyc-col-vendor">Vendor</th>
                    <th className="kyc-col-details">Vendor Details</th>
                    <th className="kyc-col-type">Document Type</th>
                    <th className="kyc-col-number">Document Number</th>
                    <th className="kyc-col-date">Submitted</th>
                    <th className="kyc-col-status">Status</th>
                    <th className="kyc-col-verified">Verified By</th>
                    <th className="kyc-col-expiry">Expiry Date</th>
                    <th className="kyc-col-actions">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {loading && (
                    <tr>
                      <td colSpan={10} className="kyc-loading">
                        <div className="kyc-loading-spinner">Loading documents...</div>
                      </td>
                    </tr>
                  )}
                  {!loading && list.map(row => (
                    <tr key={row.id} className="kyc-table-row" onClick={() => openPreviewModal(row.id)}>
                      <td 
                        className="kyc-col-checkbox" 
                        data-label="Select" 
                        onClick={(e) => { e.stopPropagation(); toggleRowSelected(row.id); }}
                      >
                        <input type="checkbox" checked={selectedRows.has(row.id)} onChange={() => {}} />
                      </td>
                      <td className="kyc-col-vendor" data-label="Vendor">
                        <div className="kyc-vendor-info">
                          <div className="kyc-vendor-name">{row.vendor_name}</div>
                        </div>
                      </td>
                      <td className="kyc-col-details" data-label="Vendor Details">
                        <div className="kyc-vendor-details">
                          <div className="kyc-vendor-id">#{row.vendor_id}</div>
                          <div className="kyc-vendor-name-small">{row.vendor_name}</div>
                        </div>
                      </td>
                      <td className="kyc-col-type" data-label="Document Type">
                        <span className="kyc-doc-type">{row.document_type}</span>
                      </td>
                      <td className="kyc-col-number" data-label="Document Number">
                        <span className="kyc-doc-number">{row.document_number || '-'}</span>
                      </td>
                      <td className="kyc-col-date" data-label="Submitted">
                        <div className="kyc-date-info">
                          <div className="kyc-date">{new Date(row.uploaded_at).toLocaleDateString()}</div>
                          <div className="kyc-time">{new Date(row.uploaded_at).toLocaleTimeString()}</div>
                        </div>
                      </td>
                      <td className="kyc-col-status" data-label="Status">
                        <span className={`kyc-status-badge kyc-status-${String(row.doc_status||'').toLowerCase()}`}>
                          {row.doc_status}
                        </span>
                      </td>
                      <td className="kyc-col-verified" data-label="Verified By">
                        <span className="kyc-verified-by">{row.verified_by || '-'}</span>
                      </td>
                      <td className="kyc-col-expiry" data-label="Expiry Date">
                        <span className="kyc-expiry-date">
                          {row.expiry_date ? new Date(row.expiry_date).toLocaleDateString() : '-'}
                        </span>
                      </td>
                      <td className="kyc-col-actions" data-label="Actions" onClick={(e) => e.stopPropagation()}>
                        <div className="kyc-action-buttons">
                          <button className="kyc-action-btn kyc-btn-approve" onClick={async (e) => { 
                            e.stopPropagation(); 
                            const ok = window.confirm('Approve this document? This will mark it as VERIFIED.'); 
                            if (!ok) return; 
                            try {
                              // Try the direct approve endpoint first (bypasses status transitions)
                              await apiClient.post(endpoints.adminDocApprove(row.id), { notes: 'Approved by admin' }, { headers: adminHeaders }); 
                              alert('Document approved successfully!');
                              loadAll(); 
                            } catch (error) {
                              console.error('Approval error:', error);
                              const errorMsg = error.response?.data?.error || 'Unknown error';
                              alert('Failed to approve document: ' + errorMsg);
                            }
                          }}>Approve</button>
                          <button className="kyc-action-btn kyc-btn-reject" onClick={async (e) => { 
                            e.stopPropagation(); 
                            const reason = window.prompt('Enter rejection reason (optional):', ''); 
                            if (reason === null) return; // User cancelled
                            try {
                              // Try the direct reject endpoint first (bypasses status transitions)
                              await apiClient.post(endpoints.adminDocReject(row.id), { reason: reason || '' }, { headers: adminHeaders }); 
                              alert('Document rejected successfully!');
                              loadAll(); 
                            } catch (error) {
                              console.error('Rejection error:', error);
                              const errorMsg = error.response?.data?.error || 'Unknown error';
                              alert('Failed to reject document: ' + errorMsg);
                            }
                          }}>Reject</button>
                          <button className="kyc-action-btn kyc-btn-download" onClick={(e) => { 
                            e.stopPropagation(); 
                            (async () => { 
                              try { 
                                // Use blob download - backend now proxies Cloudinary content
                                const response = await apiClient.get(endpoints.adminDocDownload(row.id), { 
                                  headers: adminHeaders, 
                                  responseType: 'blob' 
                                }); 
                                const url = window.URL.createObjectURL(new Blob([response.data])); 
                                const link = document.createElement('a'); 
                                link.href = url; 
                                link.setAttribute('download', row.original_name || `${row.document_type}-${row.id}`); 
                                document.body.appendChild(link); 
                                link.click(); 
                                link.remove(); 
                                window.URL.revokeObjectURL(url);
                              } catch (error) { 
                                console.error('Download error:', error);
                                // Fallback: try to open the document in a new tab
                                try {
                                  const fallbackUrl = `${process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000'}/api/admin/documents/${row.id}/download`;
                                  window.open(fallbackUrl, '_blank');
                                } catch (fallbackError) {
                                  alert('Download failed: ' + (error.response?.data?.error || 'File not found or network error')); 
                                }
                              } 
                            })(); 
                          }}>Download</button>
                          <button 
                            className="kyc-action-btn kyc-btn-ocr" 
                            onClick={(e) => { e.stopPropagation(); runOCR(row.id); }}
                            disabled={buttonLoading[`ocr-${row.id}`]}
                          >
                            {buttonLoading[`ocr-${row.id}`] ? 'Processing...' : 'OCR'}
                          </button>
                          <button className="kyc-action-btn kyc-btn-delete" onClick={(e) => { e.stopPropagation(); deleteDoc(row.id); }}>Delete</button>
                          <button 
                            className="kyc-action-btn kyc-btn-verify" 
                            onClick={async (e) => { 
                              e.stopPropagation(); 
                              const ok = window.confirm('Verify this document using the Expected Fields? Make sure to set the expected values in the right panel first.'); 
                              if (!ok) return; 
                              
                              try {
                                setButtonLoading(prev => ({ ...prev, [`verify-${row.id}`]: true }));
                                await verifyDoc(row.id);
                              } finally {
                                setButtonLoading(prev => ({ ...prev, [`verify-${row.id}`]: false }));
                              }
                            }}
                            disabled={buttonLoading[`verify-${row.id}`]}
                          >
                            {buttonLoading[`verify-${row.id}`] ? 'Verifying...' : 'Verify'}
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                  {!loading && list.length === 0 && (
                    <tr>
                      <td colSpan={10} className="kyc-empty">
                        <div className="kyc-empty-state">
                          <div className="kyc-empty-icon"></div>
                          <div className="kyc-empty-text">No documents found</div>
                          <div className="kyc-empty-subtext">Try adjusting your filters to see more results</div>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <div className="kyc-pagination">
              <div className="kyc-pagination-info">
                <span className="kyc-total-count">Total: {total} documents</span>
                <span className="kyc-page-info">Page {page} of {Math.ceil(total / limit)}</span>
              </div>
              <div className="kyc-pagination-controls">
                <button 
                  className="kyc-pagination-btn" 
                  disabled={page <= 1} 
                  onClick={() => setPage(p => Math.max(1, p - 1))}
                >
                  Previous
                </button>
                <span className="kyc-page-number">{page}</span>
                <button 
                  className="kyc-pagination-btn" 
                  disabled={(page * limit) >= total} 
                  onClick={() => setPage(p => p + 1)}
                >
                  Next
                </button>
              </div>
            </div>
          </div>
            <div className="kyc-audit-section">
              <div className="kyc-audit-header">
                <h3>Global Audit Trail</h3>
                <p>Track all KYC document actions and changes</p>
              </div>
              
              <div className="kyc-audit-filters">
                <div className="kyc-audit-filter-group">
                  <label className="kyc-audit-filter-label">Vendor Search</label>
                  <input 
                    className="kyc-audit-filter-input" 
                    placeholder="Search by vendor name or ID" 
                    value={auditFilters.vendor} 
                    onChange={e => { setAuditPage(1); setAuditFilters({ ...auditFilters, vendor: e.target.value }); }} 
                  />
                </div>
                <div className="kyc-audit-filter-group">
                  <label className="kyc-audit-filter-label">Action Type</label>
                  <input 
                    className="kyc-audit-filter-input" 
                    placeholder="approve/reject/ocr/verify/notify" 
                    value={auditFilters.action} 
                    onChange={e => { setAuditPage(1); setAuditFilters({ ...auditFilters, action: e.target.value }); }} 
                  />
                </div>
                <div className="kyc-audit-filter-group">
                  <label className="kyc-audit-filter-label">Admin ID</label>
                  <input 
                    className="kyc-audit-filter-input" 
                    placeholder="Admin identifier" 
                    value={auditFilters.admin} 
                    onChange={e => { setAuditPage(1); setAuditFilters({ ...auditFilters, admin: e.target.value }); }} 
                  />
                </div>
              </div>
              
              <div className="kyc-audit-table-container">
                <table className="kyc-audit-table">
                  <thead>
                    <tr>
                      <th className="kyc-audit-col-time">Time</th>
                      <th className="kyc-audit-col-vendor">Vendor</th>
                      <th className="kyc-audit-col-doc">Document</th>
                      <th className="kyc-audit-col-action">Action</th>
                      <th className="kyc-audit-col-admin">Admin</th>
                      <th className="kyc-audit-col-notes">Notes</th>
                    </tr>
                  </thead>
                  <tbody>
                    {auditLoading && (
                      <tr>
                        <td colSpan={6} className="kyc-audit-loading">
                          <div className="kyc-audit-loading-spinner">Loading audit trail...</div>
                        </td>
                      </tr>
                    )}
                    {!auditLoading && auditGlobal.map(r => (
                      <tr key={r.id} className="kyc-audit-row">
                        <td className="kyc-audit-col-time">
                          <div className="kyc-audit-time">
                            <div className="kyc-audit-date">{new Date(r.created_at).toLocaleDateString()}</div>
                            <div className="kyc-audit-time-small">{new Date(r.created_at).toLocaleTimeString()}</div>
                          </div>
                        </td>
                        <td className="kyc-audit-col-vendor">
                          <div className="kyc-audit-vendor">
                            <div className="kyc-audit-vendor-name">{r.vendor_name || r.vendor_id}</div>
                          </div>
                        </td>
                        <td className="kyc-audit-col-doc">
                          <div className="kyc-audit-doc">
                            <div className="kyc-audit-doc-type">{r.document_type || '-'}</div>
                            {r.original_name && (
                              <div className="kyc-audit-doc-name">({r.original_name})</div>
                            )}
                          </div>
                        </td>
                        <td className="kyc-audit-col-action">
                          <span className={`kyc-audit-action kyc-audit-action-${r.action?.toLowerCase()}`}>
                            {r.action}
                          </span>
                        </td>
                        <td className="kyc-audit-col-admin">
                          <span className="kyc-audit-admin">{r.admin_identifier || '-'}</span>
                        </td>
                        <td className="kyc-audit-col-notes">
                          <span className="kyc-audit-notes">{r.notes || ''}</span>
                        </td>
                      </tr>
                    ))}
                    {!auditLoading && auditGlobal.length === 0 && (
                      <tr>
                        <td colSpan={6} className="kyc-audit-empty">
                          <div className="kyc-audit-empty-state">
                            <div className="kyc-audit-empty-icon"></div>
                            <div className="kyc-audit-empty-text">No audit records found</div>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              
              <div className="kyc-audit-pagination">
                <div className="kyc-audit-pagination-info">
                  <span className="kyc-audit-total-count">Total: {auditTotal} records</span>
                  <span className="kyc-audit-page-info">Page {auditPage} of {Math.ceil(auditTotal / 20)}</span>
                </div>
                <div className="kyc-audit-pagination-controls">
                  <button 
                    className="kyc-audit-pagination-btn" 
                    disabled={auditPage <= 1} 
                    onClick={() => setAuditPage(p => Math.max(1, p - 1))}
                  >
                    Previous
                  </button>
                  <span className="kyc-audit-page-number">{auditPage}</span>
                  <button 
                    className="kyc-audit-pagination-btn" 
                    disabled={(auditPage * 20) >= auditTotal} 
                    onClick={() => setAuditPage(p => p + 1)}
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>
          </div>

      {isModalOpen && (
        <div className="kyc-modal-overlay" onClick={closePreviewModal}>
          <div className="kyc-modal" onClick={(e) => e.stopPropagation()}>
            <div className="kyc-modal-header">
              <div className="kyc-modal-title">
                <h3>Document Preview & Review</h3>
                <p>Review document details and take action</p>
              </div>
              <button className="kyc-modal-close" onClick={closePreviewModal}>X</button>
            </div>
            
            <div className="kyc-modal-content">
              <div className="kyc-modal-preview">
                <div className="kyc-preview-container">
                  {(() => {
                    const d = modalDoc || selected;
                    if (!d) return <div className="kyc-no-document">No document selected</div>;
                    
                    const mime = String(d.mime_type || '').toLowerCase();
                    let imageSrc = '';
                    
                    // Handle different file path formats
                    if (d.file_path) {
                      if (d.file_path.includes('cloudinary.com')) {
                        // For Cloudinary URLs, try direct access first, fallback to proxied version
                        imageSrc = d.file_path.startsWith('http') ? d.file_path : `https:${d.file_path}`;
                      } else {
                        // Local file path
                        imageSrc = d.file_path.startsWith('/') ? d.file_path : `/${d.file_path.replace('\\','/')}`;
                      }
                    }
                    
                    if (mime.startsWith('image/') || imageSrc.match(/\.(jpg|jpeg|png|gif|webp)$/i)) {
                      return (
                        <div className="kyc-image-container">
                          <div className="kyc-image-loading" id={`loading-${d.id}`}>
                            <div className="kyc-image-loading-spinner"></div>
                            <div>Loading image...</div>
                          </div>
                          <img 
                            src={imageSrc} 
                            alt="Document Preview" 
                            className="kyc-document-image"
                            style={{ display: 'none' }}
                            onLoad={(e) => {
                              e.target.style.display = 'block';
                              const loading = document.getElementById(`loading-${d.id}`);
                              if (loading) loading.style.display = 'none';
                            }}
                            onError={(e) => {
                              console.error('Image load error:', e);
                              const loading = document.getElementById(`loading-${d.id}`);
                              if (loading) loading.style.display = 'none';
                              
                              // Try proxied version if direct Cloudinary access fails
                              if (imageSrc.includes('cloudinary.com') && !e.target.dataset.triedProxy) {
                                e.target.dataset.triedProxy = 'true';
                                e.target.src = `${process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000'}/api/admin/documents/${d.id}/download`;
                                return;
                              }
                              
                              e.target.style.display = 'none';
                              e.target.nextSibling.style.display = 'flex';
                            }}
                          />
                          <div style={{ display: 'none', padding: '20px', textAlign: 'center', color: '#6b7280', flexDirection: 'column', alignItems: 'center' }}>
                            <div style={{ fontSize: '48px', marginBottom: '12px' }}>⚠️</div>
                            <div style={{ fontSize: '16px', fontWeight: '600', marginBottom: '8px' }}>Unable to load image preview</div>
                            <div style={{ fontSize: '14px', marginBottom: '16px' }}>
                              File: {d.original_name || 'Unknown'}
                            </div>
                            <div style={{ fontSize: '12px', color: '#9ca3af', marginBottom: '16px' }}>
                              This might be due to CORS restrictions or file access issues
                            </div>
                            <button 
                              style={{ padding: '10px 20px', background: '#3b82f6', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: '500' }}
                              onClick={() => {
                                if (imageSrc.includes('cloudinary.com')) {
                                  window.open(imageSrc, '_blank');
                                } else {
                                  window.open(`${process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000'}/api/admin/documents/${d.id}/download`, '_blank');
                                }
                              }}
                            >
                              Open in New Tab
                            </button>
                          </div>
                        </div>
                      );
                    }
                    
                    // For non-image files, show file info and download option
                    return (
                      <div className="kyc-no-document" style={{ padding: '40px', textAlign: 'center' }}>
                        <div style={{ fontSize: '48px', marginBottom: '16px' }}>📄</div>
                        <div style={{ fontSize: '16px', fontWeight: '600', marginBottom: '8px' }}>
                          {d.document_type?.toUpperCase()} Document
                        </div>
                        <div style={{ fontSize: '14px', color: '#6b7280', marginBottom: '16px' }}>
                          {d.original_name || 'Document file'}
                        </div>
                        <div style={{ fontSize: '12px', color: '#9ca3af', marginBottom: '20px' }}>
                          File type: {mime || 'Unknown'}<br/>
                          Preview not available for this file type
                        </div>
                        <button 
                          style={{ padding: '10px 20px', background: '#3b82f6', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: '500' }}
                          onClick={() => {
                            if (imageSrc.includes('cloudinary.com')) {
                              window.open(imageSrc, '_blank');
                            } else {
                              window.open(`${process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000'}/api/admin/documents/${d.id}/download`, '_blank');
                            }
                          }}
                        >
                          Open Document
                        </button>
                      </div>
                    );
                  })()}
                </div>
                
                <div className="kyc-preview-actions">
                  <button 
                    className="kyc-preview-btn kyc-btn-ocr" 
                    onClick={() => modalDoc && runOCR(modalDoc.id)}
                    disabled={buttonLoading[`ocr-${modalDoc?.id}`]}
                  >
                    {buttonLoading[`ocr-${modalDoc?.id}`] ? 'Processing...' : 'Run OCR'}
                  </button>
                  <button className="kyc-preview-btn kyc-btn-delete" onClick={() => modalDoc && deleteDoc(modalDoc.id)}>
                    Delete Document
                  </button>
                  <button className="kyc-preview-btn kyc-btn-download" onClick={async () => {
                    try {
                      if (!modalDoc) return;
                      
                      // Use blob download - backend now proxies Cloudinary content
                      const response = await apiClient.get(endpoints.adminDocDownload(modalDoc.id), { 
                        headers: adminHeaders, 
                        responseType: 'blob' 
                      });
                      const url = window.URL.createObjectURL(new Blob([response.data]));
                      const link = document.createElement('a');
                      link.href = url;
                      link.setAttribute('download', modalDoc.original_name || `${modalDoc.document_type}-${modalDoc.id}`);
                      document.body.appendChild(link);
                      link.click();
                      link.remove();
                      window.URL.revokeObjectURL(url);
                    } catch (error) { 
                      console.error('Download error:', error);
                      // Fallback: try to open the document in a new tab
                      try {
                        const fallbackUrl = `${process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000'}/api/admin/documents/${modalDoc.id}/download`;
                        window.open(fallbackUrl, '_blank');
                      } catch (fallbackError) {
                        alert('Download failed: ' + (error.response?.data?.error || 'File not found or network error')); 
                      }
                    }
                  }}>
                    Download
                  </button>
                </div>
              </div>
              
              <div className="kyc-modal-details">
                <div className="kyc-document-info">
                  <div className="kyc-doc-header">
                    <h4>{modalDoc?.document_type?.toUpperCase()} Document</h4>
                    <span className="kyc-doc-id">#{modalDoc?.id}</span>
                  </div>
                  <div className="kyc-doc-meta">
                    <div className="kyc-meta-item">
                      <span className="kyc-meta-label">Submitted:</span>
                      <span className="kyc-meta-value">{new Date(modalDoc?.uploaded_at || Date.now()).toLocaleString()}</span>
                    </div>
                    <div className="kyc-meta-item">
                      <span className="kyc-meta-label">Status:</span>
                      <span className={`kyc-status-badge kyc-status-${String(modalDoc?.doc_status||'').toLowerCase()}`}>
                        {modalDoc?.doc_status || 'UPLOADED'}
                      </span>
                    </div>
                    <div className="kyc-meta-item">
                      <span className="kyc-meta-label">Verified By:</span>
                      <span className="kyc-meta-value">{modalDoc?.verified_by || '-'}</span>
                    </div>
                  </div>
                </div>
                
                <div className="kyc-expected-fields">
                  <h5>Expected Verification Fields</h5>
                  <div className="kyc-field-group">
                    <label className="kyc-field-label">Expected Name</label>
                    <input 
                      className="kyc-field-input" 
                      placeholder="Enter expected name from document" 
                      value={expected.name} 
                      onChange={e => setExpected({ ...expected, name: e.target.value })} 
                    />
                  </div>
                  <div className="kyc-field-group">
                    <label className="kyc-field-label">Expected Number (PAN/FSSAI/Aadhaar)</label>
                    <input 
                      className="kyc-field-input" 
                      placeholder="Enter expected document number" 
                      value={expected.pan} 
                      onChange={e => setExpected({ ...expected, pan: e.target.value })} 
                    />
                  </div>
                  <div style={{ fontSize: '12px', color: '#6b7280', marginTop: '8px', fontStyle: 'italic' }}>
                    💡 Tip: Run OCR first, then use "Apply Suggestions" to auto-fill these fields
                  </div>
                </div>
                
                <div className="kyc-modal-actions">
                  <button className="kyc-action-btn kyc-btn-approve" onClick={async () => {
                    if (!modalDoc) return;
                    const ok = window.confirm('Approve this document?');
                    if (!ok) return;
                    try {
                      // Use the direct approve endpoint
                      await apiClient.post(endpoints.adminDocApprove(modalDoc.id), { notes: 'Approved by admin' }, { headers: adminHeaders });
                      alert('Document approved successfully!');
                      await loadAll();
                      closePreviewModal();
                    } catch (error) {
                      console.error('Approval error:', error);
                      const errorMsg = error.response?.data?.error || 'Unknown error';
                      alert('Failed to approve document: ' + errorMsg);
                    }
                  }}>
                    Approve Document
                  </button>
                  <button className="kyc-action-btn kyc-btn-reject" onClick={async () => {
                    if (!modalDoc) return;
                    const reason = window.prompt('Enter rejection reason (optional):', '');
                    if (reason === null) return; // User cancelled
                    try {
                      // Use the direct reject endpoint
                      await apiClient.post(endpoints.adminDocReject(modalDoc.id), { reason: reason || '' }, { headers: adminHeaders });
                      alert('Document rejected successfully!');
                      await loadAll();
                      closePreviewModal();
                    } catch (error) {
                      console.error('Rejection error:', error);
                      const errorMsg = error.response?.data?.error || 'Unknown error';
                      alert('Failed to reject document: ' + errorMsg);
                    }
                  }}>
                    Reject Document
                  </button>
                  <button 
                    className="kyc-action-btn kyc-btn-verify" 
                    onClick={async () => {
                      if (!modalDoc) return;
                      const ok = window.confirm('Verify using expected fields? Make sure to fill in the expected name and number fields above.');
                      if (!ok) return;
                      
                      try {
                        setButtonLoading(prev => ({ ...prev, [`verify-${modalDoc.id}`]: true }));
                        await verifyDoc(modalDoc.id);
                        await loadAll();
                      } finally {
                        setButtonLoading(prev => ({ ...prev, [`verify-${modalDoc.id}`]: false }));
                      }
                    }}
                    disabled={buttonLoading[`verify-${modalDoc?.id}`]}
                  >
                    {buttonLoading[`verify-${modalDoc?.id}`] ? 'Verifying...' : 'Verify Document'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminKYCReview;


